/**
 * @generated SignedSource<<3675ab32fd0e509b7f3a23138ed02cd0>>
 * @relayHash 7c35b7c705a2189ec4fdce9b4cc05ca1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 12e91db1db4da369d1aa41539383967aae8b59276836b358878b45e80d1c5de3

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFieldSchemeAssociatedFieldsInput = {
  nameOrDescriptionFilter?: string | null | undefined;
  schemeId: string;
};
export type FieldSchemePageQuery$variables = {
  cloudId: string;
  fieldSchemeAri: string;
  input: JiraFieldSchemeAssociatedFieldsInput;
  schemeId: string;
};
export type FieldSchemePageQuery$data = {
  readonly fieldSchemeNode: {
    readonly " $fragmentSpreads": FragmentRefs<"PageHeaderGroup">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AssociatedFieldsTable">;
};
export type FieldSchemePageQuery = {
  response: FieldSchemePageQuery$data;
  variables: FieldSchemePageQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider": isFieldSchemeOperationsEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider": isEfaCmpBetaFieldsManagementFeaturesEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isEfaCmpBetaFieldsManagementFeaturesEnabled_provider from '@atlassian/jira-relay-provider/src/is-efa-cmp-beta-fields-management-features-enabled.relayprovider';
import isFieldSchemeOperationsEnabled_provider from '@atlassian/jira-relay-provider/src/is-efa-cmp-field-scheme-operations-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSchemeAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schemeId"
},
v4 = {
  "kind": "Variable",
  "name": "input",
  "variableName": "input"
},
v5 = {
  "kind": "Variable",
  "name": "schemeId",
  "variableName": "schemeId"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "fieldSchemeAri"
  }
],
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  },
  (v4/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "description"
},
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FieldSchemePageQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "AssociatedFieldsTable"
      },
      {
        "alias": "fieldSchemeNode",
        "args": (v6/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "PageHeaderGroup"
              }
            ],
            "type": "JiraFieldScheme"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "FieldSchemePageQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "JiraFieldSchemeAssociatedFieldsConnection",
        "kind": "LinkedField",
        "name": "jira_fieldSchemeAssociatedFields",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraFieldSchemeAssociatedFieldsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraFieldSchemeAssociatedField",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "fieldId"
                      },
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "typeName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "typeKey"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFieldLocked"
                  },
                  {
                    "concreteType": "JiraIssueFieldConfig",
                    "kind": "LinkedField",
                    "name": "fieldConfig",
                    "plural": false,
                    "selections": [
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "JiraFieldSchemeOperations",
                            "kind": "LinkedField",
                            "name": "fieldSchemeOperations",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canRemove"
                              }
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/)
                    ]
                  },
                  (v11/*: any*/),
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueFieldConfig",
                        "kind": "LinkedField",
                        "name": "fieldConfig",
                        "plural": false,
                        "selections": [
                          {
                            "args": [
                              (v5/*: any*/)
                            ],
                            "concreteType": "JiraFieldWorkTypeDescriptionCustomization",
                            "kind": "LinkedField",
                            "name": "descriptionCustomisations",
                            "plural": true,
                            "selections": [
                              (v10/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isHighlighted"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      {
        "args": (v7/*: any*/),
        "filters": [
          "cloudId",
          "input"
        ],
        "handle": "connection",
        "key": "associatedFieldsTable_adminPagesFieldScheme_jira_fieldSchemeAssociatedFields",
        "kind": "LinkedHandle",
        "name": "jira_fieldSchemeAssociatedFields"
      },
      {
        "alias": "fieldSchemeNode",
        "args": (v6/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "schemeId"
              },
              (v9/*: any*/),
              {
                "kind": "ScalarField",
                "name": "projectsCount"
              }
            ],
            "type": "JiraFieldScheme"
          },
          (v8/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "12e91db1db4da369d1aa41539383967aae8b59276836b358878b45e80d1c5de3",
    "metadata": {},
    "name": "FieldSchemePageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider": isFieldSchemeOperationsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider": isEfaCmpBetaFieldsManagementFeaturesEnabled_provider
    }
  }
};
})();

(node as any).hash = "da5ebcd1436b86b03226a915f9febb20";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
